import { QueryClientProvider } from '@systemeio/file-manager'
import { HelpBots } from 'help-bots'
import Head from 'next/head'
import Router, { useRouter } from 'next/router'
import React from 'react'
import Header from 'shared/components/header'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import useUser from 'shared/hooks/use-user'
import { useEmailStatusNotification } from 'shared/notifications/hooks/use-email-status-notification'
import { usePaymentNotification } from 'shared/notifications/hooks/use-payment-notification'
import { Snow } from './snow'
import { useChristmas } from './snow/use-christmas'
import { useGuard } from 'shared/hooks/use-guard'
import { Banner } from 'shared/components/banner'

const disabledPageRoute = '/disabled'

function DashboardLayout({ children, browserTabTitle }: React.PropsWithChildren<any>) {
  useGuard()
  useEmailStatusNotification()
  usePaymentNotification()

  const christmasFeatureIsOn = useChristmas()

  const { t } = useLocoTranslation()

  const { pathname } = useRouter()

  const { isDisabled } = useUser()

  if (isDisabled && pathname !== disabledPageRoute) {
    Router.replace(disabledPageRoute)
  }

  return (
    <>
      <HelpBots />
      <Head>
        <title>{t(browserTabTitle)}</title>
      </Head>
      <div>
        <Header />
        <Banner />
        <div className="px-4 sm:px-6 md:px-14">
          <QueryClientProvider>
            <main className="py-5">{children}</main>
          </QueryClientProvider>
        </div>
      </div>
      {christmasFeatureIsOn && <Snow />}
    </>
  )
}

export default DashboardLayout
